import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ResendOrganizationUserInvitationMutation } from "../graphql/mutations";
import type {
  ResendOrganizationUserInvitationMutationType,
  ResendOrganizationUserInvitationMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useResendOrganizationUserInvitationMutation = (
  options?: MutationHookOptions<
    ResendOrganizationUserInvitationMutationType,
    ResendOrganizationUserInvitationMutationVariablesType
  >
) => {
  return useMutation<
    ResendOrganizationUserInvitationMutationType,
    ResendOrganizationUserInvitationMutationVariablesType
  >(ResendOrganizationUserInvitationMutation, options);
};
